export function openGoogleCalendar(meeting) {
  const formatGCalDate = (isoString) => {
    if (!isoString) return '';
    try {
      const date = new Date(isoString);
      if (isNaN(date.getTime())) return '';
      // Google Calendar format: YYYYMMDDTHHmmssZ
      return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
    } catch {
      return '';
    }
  };

  const start = formatGCalDate(meeting.startAtUtc || meeting.startTime);
  const end = formatGCalDate(meeting.endAtUtc || meeting.endTime);
  
  if (!start || !end) {
    console.warn('Cannot open Calendar: Missing valid start or end date.');
    return;
  }

  const url = new URL('https://calendar.google.com/calendar/render');
  url.searchParams.append('action', 'TEMPLATE');
  url.searchParams.append('text', meeting.title || meeting.name || 'Meeting');
  url.searchParams.append('dates', `${start}/${end}`);
  
  if (meeting.goal) {
    url.searchParams.append('details', meeting.goal);
  }
  if (meeting.location || meeting.zoomLink) {
    url.searchParams.append('location', meeting.location || meeting.zoomLink || '');
  }

  // Open in a new tab/window
  window.open(url.toString(), '_blank');
}
